import React, { useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import "../../../style/customers.css";

function CustomersOverviewPrint() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPrintedRef = useRef(false);
  const customers = useMemo(() => location.state?.customers || [], [location.state?.customers]);

  // Helper function to format balance
  const formatBalance = (balance) => {
    const amount = parseFloat(balance || 0);
    return `€${amount.toFixed(2)}`;
  };

  // Auto-open print dialog when component loads
  useEffect(() => {
    if (customers.length > 0 && !hasPrintedRef.current) {
      // Small delay to ensure DOM is fully rendered
      const timer = setTimeout(() => {
        window.print();
        hasPrintedRef.current = true;
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [customers]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate("/finance/reports");
  };

  // Show loading state if no customers
  if (!customers || customers.length === 0) {
    return (
      <div className="print-invoice-container">
        <div className="print-invoice-header">
          <button className="print-back-btn" onClick={handleBack}>
            <ArrowLeft size={15} />
            Back to Reports
          </button>
        </div>
        <div className="loading-container">
          <p>
            No customer data available. Please export from the Reports page.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="print-invoice-container">
      {/* Header with Back and Print buttons */}
      <div className="print-invoice-header">
        <div></div>

        <div>
          <button className="print-print-btn" onClick={handlePrint}>
            <Printer size={16} />
            Print
          </button>
        </div>
      </div>

      {/* Customer Table */}
      <div className="print-invoice-content">
        {/* Invoice Header Info */}
        <div
          className="print-invoice-info"
          style={{ borderBottom: "1px solid #EAEEF2" }}
        >
          <div className="print-invoice-id" style={{ borderBottom: "none" }}>
            Customers Overview List
          </div>
          <div className="print-invoice-date">
            Generated on: {new Date().toLocaleDateString()}
          </div>
        </div>

        <div className="customers-table-wrapper">
          <div className="customer-table-responsive">
            <table className="customer-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>NAME</th>
                  <th>EMAIL</th>
                  <th>PHONE</th>
                  <th>ADDRESS</th>
                  <th>BALANCE</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((customer) => (
                  <tr key={customer.id}>
                    <td>{customer.id || "--"}</td>
                    <td>{customer.name || "--"}</td>
                    <td>{customer.user_email || customer.email || "--"}</td>
                    <td>{customer.mobile || customer.phone || "--"}</td>
                    <td>{customer.address || "--"}</td>
                    <td>
                      <span
                        className={`balance-badge ${
                          (customer.balance || 0) >= 0 ? "positive" : "negative"
                        }`}
                      >
                        {formatBalance(customer.balance || 0)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomersOverviewPrint;
